import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';
import { DatasetByIdProps } from 'utils/types';

export const datasetKey = 'dataset';

interface Props {
  id?: number | null;
  preferCachedData?: boolean;
}

const useDatasetById = ({ id, preferCachedData = false }: Props) => useQuery({
  queryKey: [datasetKey, id],
  queryFn: () => {
    const prospectDetails = localStorage.getItem('prospect-details');

    try {
      if (!prospectDetails) {
        return agent
          .getClient()(`/prospect/dataset/${id}`)
          .then((response) => response.data as DatasetByIdProps);
      }

      const details = JSON.parse(prospectDetails);
      const detail = details[id || ''];

      if (detail && preferCachedData) {
        return detail as DatasetByIdProps;
      }

      return agent
        .getClient()(`/prospect/dataset/${id}`)
        .then((response) => response.data as DatasetByIdProps);
    } catch (e) {
      console.error('error while parsing prospect details', e);
    }
  },
  enabled: !!id,
});

export default useDatasetById;
